<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']"
    titlePrefix="NONCEBEATS – Seamless Global Ad Trading Platform"
    metaDescription="Join NONCEBEATS to connect advertisers and publishers worldwide. Buy and sell premium ad inventory in real time, optimize campaigns, and maximize ROI with transparency and efficiency.">

    <section class="hero-section">
      <div class="hero-section__content">
        <h1 class="hero-section__title">Effortlessly Start Your <br> Advertising Journey</h1>
        <p class="hero-section__subtitle">
          Delivering targeted ad campaigns with advanced analytics, we help you reach the right
          users at the right time, driving engagement and boosting your advertising ROI.
        </p>
        <a href="/#footer-section" class="hero-section__cta-button">
          <span>Contact Us</span>
          <img src="@/assets/banner-contact-arrow.svg" alt="arrow">
        </a>
      </div>
    </section>

    <section class="data-section">
      <div class="data-section__item" v-for="(item, index) in dataItems" :key="index">
        <div class="data-section__value">{{ item.value }}</div>
        <div class="data-section__label">{{ item.label }}</div>
      </div>
    </section>

    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Our Advertising Solutions</h2>
        <p class="services-section__subtitle">
          We provide cutting-edge ad services designed to help advertisers expand reach, optimize
          campaigns, and drive measurable ROI.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="why-section">
      <div class="why-section__header">
        <h2 class="why-section__title">Why Partner With Us</h2>
        <p class="why-section__subtitle">
          Reliable technology, dedicated expertise, and full transparency to drive your advertising
          success.
        </p>
      </div>
      <div class="why-section__content">
        <div class="why-section__image-container">
          <img src="@/assets/why.png" alt="Why choose us placeholder" class="why-section__image">
        </div>
        <div class="why-section__features">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <div class="feature-item__number">{{ index + 1 }}</div>
            <div class="feature-item__text">
              <h3 class="feature-item__title">{{ feature.title }}</h3>
              <p class="feature-item__description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section">
      <p class="trust-section__text">Trusted by Industry Leaders Worldwide</p>
    </section>

    <section class="partners-section">
      <div class="partners-section__header">
        <h2 class="partners-section__title">Partners</h2>
      </div>
      <div class="partners-section__grid">
        <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
          <img :src="partner.image" :alt="partner.name">
        </div>
      </div>
    </section>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {
      dataItems: [
        { value: '500M+', label: 'Ads optimized and served to engaged users monthly.' },
        { value: '98%', label: 'Campaign success rate for seamless ad delivery.' },
        { value: '24/7', label: 'Continuous tracking to maximize performance and ROI.' }
      ],
      services: [
        {
          title: 'High-Quality Ad Placements',
          description: 'Access premium ad spaces across top publishers and trusted digital channels for maximum visibility.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Programmatic Bidding',
          description: 'Use intelligent real-time bidding technology to engage your audience at the optimal moment.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Performance Optimization',
          description: 'Boost campaign results with continuous data analysis, A/B testing, and precise targeting strategies.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Expert Support Team',
          description: 'Receive 24/7 guidance from a dedicated team to ensure smooth campaign execution and actionable insights.',
          image: require('@/assets/service-4.png')
        }
      ],
      features: [
        {
          title: 'Global Platform Connectivity',
          description: 'Seamlessly connect to leading advertising networks worldwide, ensuring your campaigns reach the most relevant audience.'
        },
        {
          title: 'Professional Support Team',
          description: 'Work with experienced specialists who provide tailored guidance and rapid solutions for uninterrupted campaign performance.'
        },
        {
          title: 'Transparent & Efficient Campaign Management',
          description: 'Leverage real-time bidding and clear reporting to ensure fair pricing while maximizing ROI.'
        }
      ],
      partners: [
        { name: 'Amazon', image: require('@/assets/Amazon.png') },
        { name: 'Yandex', image: require('@/assets/Yandex.png') },
        { name: 'Zalora', image: require('@/assets/Zalora.png') },
        { name: 'Google', image: require('@/assets/Google.png') },
        { name: 'Tinder', image: require('@/assets/Tinder.png') },
        { name: 'Meta', image: require('@/assets/Meta.png') },
        { name: 'Telecoming', image: require('@/assets/Telecoming.png') },
        { name: 'TikTok', image: require('@/assets/TikTok.png') }
      ]
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

  }
};
</script>

